export default __webpack_public_path__ + "static/media/AbtP.1760bd23.jpg";